import {dataLimitMode} from '@/models/ui/GraphUiState'

export class AllGraphUiState {
    public typeUiid:string
    public refresh:boolean
    public dataLimit:string
    public gliderIdx:number

    constructor({                
                typeUiid="detail", //detail ou global
                refresh=false,
                dataLimit=dataLimitMode.LAST_12H,
                gliderIdx=0
            } = {}) {  
        this.typeUiid = typeUiid
        this.refresh = refresh
        this.dataLimit = dataLimit
        this.gliderIdx = gliderIdx
    }
}